/** @import modules */

import { useTranslation }           from "react-i18next";

import { useParams, useNavigate }   from "react-router-dom";

/** @import hooks */

import { TyresNavigator }           from "../../../../../Hooks/TyresNavigator";

/** @import components */

import SearchableSelect             from "../../../../Shared/SearchableSelect";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns OEM filter component
 * 
 */

const OEM = ( { attributes } ) => { const 

    { t }               = useTranslation    (),

    navigate            = useNavigate       (),

    { parameters }      = useParams         (),

    Filter = ( value ) => { const 

        object = { f : 12, l: null, a: null, b: null, sp: ( value === "default" ) ? null : value, loc: window.pageYOffset };

        return navigate (  
            
            `/shop/tyres/${
            
                new URLSearchParams ( TyresNavigator ( parameters, object ) ).toString () }` );

    };

    /** @return component */

    return ( <div className="content manufacturers">

        <div className="select shadow-select">

            <SearchableSelect
                options={ attributes }
                value={ new URLSearchParams ( parameters ).get ( "sp" ) || "default" }
                onChange={ Filter }
                label={ t ( "select_option" ) }
            />

        </div>

    </div> );

}

/** @export OEM */
 
export default OEM;